/**
 * Email popup open/close timing (works with Klaviyo or Shopify fallback forms).
 * Shows once per browser; Klaviyo-hosted popups are suppressed (theme popup handles signup).
 */
(function () {
  var popup = document.getElementById('sf-email-popup');
  if (!popup) return;

  var STORAGE_KEY = 'sf_email_popup_seen';
  var isDesignMode = window.Shopify && Shopify.designMode;
  var delay = parseInt(popup.getAttribute('data-sf-popup-delay'), 10) || 1800;
  var openTimer = null;

  function hasSeenPopup() {
    if (isDesignMode) return false;
    try {
      return window.localStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
      return true;
    }
  }

  function markPopupSeen() {
    if (isDesignMode) return;
    try {
      window.localStorage.setItem(STORAGE_KEY, '1');
    } catch (e) {}
  }

  function openPopup() {
    if (hasSeenPopup()) return;
    popup.classList.add('sf-open');
    popup.setAttribute('aria-hidden', 'false');
    markPopupSeen();
  }

  function closePopup() {
    popup.classList.remove('sf-open');
    popup.setAttribute('aria-hidden', 'true');
    markPopupSeen();
  }

  function isThemePopupNode(node) {
    return !!(node && node.closest && node.closest('#sf-email-popup'));
  }

  /** Klaviyo.js injects its own timed popups; remove them so only our popup shows once. */
  function suppressKlaviyoPopups() {
    document.querySelectorAll('div[class*="kl-private-reset-css"]').forEach(function (node) {
      if (isThemePopupNode(node)) return;
      node.remove();
    });
    document.querySelectorAll('.klaviyo-form, [data-testid="klaviyo-form-embed"]').forEach(function (node) {
      if (isThemePopupNode(node)) return;
      node.remove();
    });
  }

  popup.addEventListener('click', function (event) {
    if (event.target === popup) closePopup();
  });

  var closeButton = popup.querySelector('[data-sf-popup-close]');
  if (closeButton) closeButton.addEventListener('click', closePopup);

  document.addEventListener('sf:klaviyo:subscribed', function () {
    markPopupSeen();
    window.setTimeout(closePopup, 2200);
  });

  var shopifyForm = popup.querySelector('.sf-shopify-newsletter-form');
  if (shopifyForm && shopifyForm.dataset.posted === 'true') {
    markPopupSeen();
    closePopup();
  }

  if (!hasSeenPopup()) {
    var scheduleOpen = function () {
      if (hasSeenPopup()) return;
      openTimer = window.setTimeout(openPopup, isDesignMode ? 400 : delay);
    };
    if (document.readyState === 'complete') {
      scheduleOpen();
    } else {
      window.addEventListener('load', scheduleOpen);
    }
  }

  if (isDesignMode && popup.dataset.sectionId) {
    document.addEventListener('shopify:section:select', function (event) {
      if (event.detail && event.detail.sectionId === popup.dataset.sectionId) {
        if (openTimer) window.clearTimeout(openTimer);
        openPopup();
      }
    });
    document.addEventListener('shopify:section:deselect', function (event) {
      if (event.detail && event.detail.sectionId === popup.dataset.sectionId) {
        closePopup();
      }
    });
  }

  suppressKlaviyoPopups();
  if (window.MutationObserver && document.body) {
    new MutationObserver(suppressKlaviyoPopups).observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
})();
